import {getSquadsJsonSuccess} from "modules/actions/squads";
import {createReducer} from "redux-act";

export const squads = createReducer<ReturnType<typeof getSquadsJsonSuccess>["payload"]>({}, []);
squads.on(getSquadsJsonSuccess, (state, payload) => payload);
